import * as HLF from "html-living-framework";
import * as Topics from "../Data/Topics";
import * as QuiltUtils from "../Utils/QuiltUtils";

type focusCallback = (p: QuiltGridFocusable) => void;

export class QuiltGridFocusable extends PIXI.Container implements HLF.Input.IFocusable {
    private _beginCallback: focusCallback;
    private _activateCallback: focusCallback;
    private _endCallback: focusCallback;
    private _size: PIXI.Point;
    private _offset: PIXI.Point;
    private _interactive: boolean;

    constructor(pBeginCallback: focusCallback, pActivateCallback: focusCallback, pEndCallback: focusCallback) {
        super();
        this._beginCallback = pBeginCallback;
        this._activateCallback = pActivateCallback;
        this._endCallback = pEndCallback;
        this._size = new PIXI.Point(QuiltUtils.TILE_WIDTH, QuiltUtils.TILE_WIDTH);
        this._offset = new PIXI.Point(0, 0);
        this._interactive = false;
        this.visible = false;
    }

    public set interactive(pValue: boolean) {
        this._interactive = pValue;
    }

    public get interactive(): boolean {
        return this._interactive;
    }

    public onFocusBegin(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_BEGIN, this);
        this._beginCallback(this);
    }

    public onFocusActivated(): void {
        this._activateCallback(this);
    }

    public onFocusEnd(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_END, this);
        this._endCallback(this);
    }

    public setSize(pWidth: number, pHeight: number): void {
        this._size.set(
            pWidth * QuiltUtils.TILE_WIDTH,
            pHeight * QuiltUtils.TILE_WIDTH,
        );
        this._offset.set(
            (pWidth - 1) * QuiltUtils.TILE_WIDTH * 0.5,
            (pHeight - 1) * QuiltUtils.TILE_WIDTH * 0.5,
        );
    }

    public getFocusPosition(): PIXI.Point {
        return (HLF.PointUtils.add(this.getGlobalPosition(), this._offset));
    }

    public getFocusSize(): PIXI.Point {
        return this._size;
    }
}
